import { useFeature } from '../FeatureToggle';
import { useOrganizationBillingStatusRetrieveQuery } from 'src/common/external/bambi-api/bambiApi';
import { useUserRoles } from 'src/features/auth/useUserRoles';

export function InactiveCustomerBanner() {
  const redStripe = 'rgb(220 38 38 / var(--tw-bg-opacity))'; // bg-red-600
  const darkRedStripe = 'rgb(127 29 29 / var(--tw-bg-opacity))'; // bg-red-900

  return (
    <div
      data-testid="inactive-banner"
      className="flex flex-row justify-center bg-red-900"
      style={{
        height: 'calc(100vh - 64px)',
        background: `repeating-linear-gradient(45deg,${redStripe},${redStripe} 10px,${darkRedStripe} 10px,${darkRedStripe} 20px)`,
      }}
    >
      <div
        className="flex flex-col gap-4 p-2"
        style={{ backgroundColor: 'rgba(255, 255, 255, .9)' }}
      >
        <h1 className="text-3xl font-bold">Organization suspended</h1>
        <p>
          Your account has been suspended for nonpayment. Please contact support
          to reinstate.
        </p>
      </div>
    </div>
  );
}

// Determines if we should show the inactive banner
export function useInactiveCustomerBanner() {
  const { isBambi, isRideOrderingPortalUser } = useUserRoles();

  const { isLoading, data } = useOrganizationBillingStatusRetrieveQuery(
    undefined,
    {
      skip: isRideOrderingPortalUser,
    }
  );
  const { isLoading: isFeatureLoading, isEnabled } = useFeature(
    'inactive organization'
  );

  // Don't show while loading the feature flag, or if the flag is false
  if (isFeatureLoading || !isEnabled) {
    return false;
  }

  // Bambi users should never see banner
  // Don't show when loading
  // Don't show if we couldn't fetch the needed data for some reason
  if (isBambi || isLoading || !data) {
    return false;
  }

  // Don't show if the customer is active, or unknown
  if (data.is_active_customer || data.is_active_customer === null) {
    return false;
  }

  // Explicitly show if the customer is not active
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (data.is_active_customer === false) {
    return true;
  }

  // Just in case something else occurs, default to not showing the banner
  return false;
}
